import { HelpCircle } from "lucide-react";
import {
  Tooltip, TooltipContent, TooltipTrigger,
} from "../ui/tooltip";

/**
 * Subtle question-mark icon that reveals a rich formula tooltip on hover /
 * focus. Used across every metric card in the Scorecard so users can always
 * inspect what a number means and where it comes from.
 */
export default function ScorecardInfoTip({ label, formula, extra, source }) {
  return (
    <Tooltip delayDuration={100}>
      <TooltipTrigger asChild>
        <button
          type="button"
          className="inline-flex"
          data-testid={`tip-${label}`}
          style={{ cursor: "help", opacity: 0.6, background: "transparent", border: "none", padding: 0 }}
        >
          <HelpCircle size={12} style={{ color: "#64748b" }} />
        </button>
      </TooltipTrigger>
      <TooltipContent
        side="top"
        style={{
          background: "#0f1218", color: "#f4c400", maxWidth: 320,
          padding: "10px 12px", borderRadius: 6, lineHeight: 1.4,
        }}
      >
        <div style={{
          fontSize: 10, fontWeight: 800, letterSpacing: "0.08em",
          textTransform: "uppercase", opacity: 0.7, marginBottom: 4,
        }}>
          {label}
        </div>
        <div style={{ fontSize: 11, fontWeight: 700, color: "#fff" }}>
          {formula}
        </div>
        {extra && (
          <div style={{ fontSize: 10, marginTop: 6, opacity: 0.75, color: "#e2e8f0", fontWeight: 500 }}>
            {extra}
          </div>
        )}
        {source && (
          <div style={{
            fontSize: 9, marginTop: 8, paddingTop: 6, borderTop: "1px solid #ffffff22",
            color: "#94a3b8", fontWeight: 600, letterSpacing: "0.02em",
          }}>
            <span style={{ opacity: 0.6, textTransform: "uppercase", marginRight: 4 }}>Fuente:</span>
            <span style={{ color: "#f4c400", fontFamily: "monospace" }}>{source}</span>
          </div>
        )}
      </TooltipContent>
    </Tooltip>
  );
}
